import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { TypedEvent, XyoWorldMinterEvents } from '@xyo-network/world-typechain'
import React from 'react'

import BidPlacedEventCard from './BidPlacedEventCard'
import RefundedCurrentBidEventCard from './RefundedCurrentBidEventCard'

export interface EventProps {
  event: TypedEvent
  id?: Quadkey
}

const EventBox: React.FC<EventProps> = (props) => {
  const { event } = props
  switch (event.event) {
    case 'BidPlaced':
      return <BidPlacedEventCard event={event as XyoWorldMinterEvents.BidPlaced} />
    case 'RefundedCurrentBid':
      return <RefundedCurrentBidEventCard event={event as XyoWorldMinterEvents.RefundedCurrentBid} />
    case 'AuctionStarted':
    default:
      return null
  }
}

export default EventBox
